(function (global) {
  'use strict';

  var RFC3339_WITH_ZONE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})$/;

  function parseInstant(value) {
    if (typeof value !== 'string' || !RFC3339_WITH_ZONE.test(value.trim())) return null;
    var timestamp = Date.parse(value.trim());
    return Number.isFinite(timestamp) ? timestamp : null;
  }

  function getWindowState(now, startAt, endAt) {
    var start = parseInstant(startAt);
    var end = parseInstant(endAt);
    if (start === null || end === null || start >= end) return 'invalid';
    if (now < start) return 'before';
    if (now >= end) return 'expired';
    return 'active';
  }

  function parseIdList(value) {
    if (typeof value !== 'string') return [];
    return value.split(',').map(function (entry) {
      return entry.trim();
    }).filter(function (id) {
      return /^\d+$/.test(id);
    });
  }

  function parseEligiblePrices(value) {
    if (typeof value !== 'string') return [];
    return value.split(',').map(function (entry) {
      return Number.parseInt(entry.trim(), 10);
    }).filter(function (price) {
      return Number.isInteger(price) && price >= 0;
    });
  }

  function calculateOffer(variant, eligiblePrices, eligibleVariantIds, discountPercent) {
    if (!variant || variant.available !== true) return null;
    if (eligibleVariantIds.length === 0 || !eligibleVariantIds.includes(String(variant.id))) return null;
    if (!eligiblePrices.includes(variant.price)) return null;
    var offerPrice = Math.round(variant.price * (100 - discountPercent) / 100);
    return {
      regularPrice: variant.price,
      offerPrice: offerPrice,
      savings: variant.price - offerPrice
    };
  }

  function formatMoney(cents, locale, currency) {
    try {
      return new Intl.NumberFormat(locale || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function readJson(root, selector) {
    var element = root.querySelector(selector);
    if (!element) return null;
    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return null;
    }
  }

  function writeText(root, selector, value) {
    var element = root.querySelector(selector);
    if (element) element.textContent = value;
  }

  function writeCountdown(root, distance) {
    var totalSeconds = Math.max(0, Math.floor(distance / 1000));
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor(totalSeconds % 86400 / 3600);
    var minutes = Math.floor(totalSeconds % 3600 / 60);
    var seconds = totalSeconds % 60;
    writeText(root, '[data-days]', String(days));
    writeText(root, '[data-hours]', String(hours).padStart(2, '0'));
    writeText(root, '[data-minutes]', String(minutes).padStart(2, '0'));
    writeText(root, '[data-seconds]', String(seconds).padStart(2, '0'));
  }

  function scheduleForPreview(settings) {
    if (settings.previewMode !== true) {
      return { startAt: settings.startAt, endAt: settings.endAt };
    }
    return {
      startAt: new Date(Date.now() - 60000).toISOString(),
      endAt: new Date(Date.now() + 172800000).toISOString()
    };
  }

  function initializeProductPromo(root) {
    if (!root || root.dataset.dmHandbagPromoInitialized === 'true') return;
    var shell = root.closest('[data-dm-handbag-promo-shell]');
    var mount = global.document.querySelector('[data-dm-handbag-promo-mount]');
    if (!shell || !mount) return;
    if (!mount.contains(shell)) mount.appendChild(shell);

    var settings = readJson(root, '[data-dm-handbag-promo-settings]');
    var variants = readJson(root, '[data-dm-handbag-promo-variants]');
    if (!settings || !Array.isArray(variants)) return;

    root.dataset.dmHandbagPromoInitialized = 'true';
    var schedule = scheduleForPreview(settings);
    var start = parseInstant(schedule.startAt);
    var end = parseInstant(schedule.endAt);
    var eligiblePrices = parseEligiblePrices(settings.eligibleVariantPrices);
    var eligibleVariantIds = parseIdList(settings.eligibleVariantIds);
    var discountPercent = Number(settings.discountPercent);
    var currentVariant = variants.find(function (variant) {
      return String(variant.id) === String(root.dataset.initialVariantId);
    }) || null;
    var timer = null;

    function render() {
      var now = Date.now();
      var state = getWindowState(now, schedule.startAt, schedule.endAt);
      var offer = calculateOffer(currentVariant, eligiblePrices, eligibleVariantIds, discountPercent);
      var visible = state === 'active' && root.dataset.productEligible === 'true' && offer !== null;
      shell.hidden = !visible;
      root.hidden = !visible;
      if (!visible) return;

      writeText(root, '[data-dm-offer-price]', formatMoney(offer.offerPrice, settings.locale, settings.currency));
      writeText(root, '[data-dm-regular-price]', formatMoney(offer.regularPrice, settings.locale, settings.currency));
      writeText(root, '[data-dm-savings]', 'Save ' + formatMoney(offer.savings, settings.locale, settings.currency));
      writeText(root, '[data-dm-discount-label]', String(discountPercent) + '% off');
      var time = root.querySelector('[data-dm-promo-time]');
      if (time) time.setAttribute('datetime', settings.endAt);
      writeCountdown(root, end - now);
    }

    function onVariantChange(event) {
      var variant = event.detail && event.detail.variant ? event.detail.variant : null;
      currentVariant = variant;
      render();
    }

    function onProductInputChange(event) {
      if (!event.target.closest('form[action*="/cart/add"]')) return;
      global.setTimeout(function () {
        var selected = global.document.querySelector('form[action*="/cart/add"] [name="id"]:checked') ||
          global.document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (!selected) return;
        currentVariant = variants.find(function (variant) {
          return String(variant.id) === String(selected.value);
        }) || currentVariant;
        render();
      }, 0);
    }

    render();
    timer = global.setInterval(render, 1000);
    global.document.addEventListener('product:variant-change', onVariantChange);
    global.document.addEventListener('variant:change', onVariantChange);
    global.document.addEventListener('change', onProductInputChange, true);

    root.dmHandbagPromoDestroy = function () {
      if (timer) global.clearInterval(timer);
      global.document.removeEventListener('product:variant-change', onVariantChange);
      global.document.removeEventListener('variant:change', onVariantChange);
      global.document.removeEventListener('change', onProductInputChange, true);
      delete root.dmHandbagPromoDestroy;
      delete root.dataset.dmHandbagPromoInitialized;
    };
  }

  function initializeBanner(root) {
    if (!root || root.dataset.dmHandbagBannerInitialized === 'true') return;
    var settings = readJson(root, '[data-dm-handbag-banner-settings]');
    if (!settings) return;
    root.dataset.dmHandbagBannerInitialized = 'true';
    var schedule = scheduleForPreview(settings);
    var end = parseInstant(schedule.endAt);
    var timer = null;

    function render() {
      var now = Date.now();
      var visible = getWindowState(now, schedule.startAt, schedule.endAt) === 'active';
      root.hidden = !visible;
      if (!visible) return;
      var time = root.querySelector('[data-dm-banner-time]');
      if (time) time.setAttribute('datetime', settings.endAt);
      writeCountdown(root, end - now);
    }

    render();
    timer = global.setInterval(render, 1000);
    root.dmHandbagBannerDestroy = function () {
      if (timer) global.clearInterval(timer);
      delete root.dmHandbagBannerDestroy;
      delete root.dataset.dmHandbagBannerInitialized;
    };
  }

  function initializeAll(container) {
    var scope = container && container.querySelectorAll ? container : global.document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-dm-handbag-product-promo]'), initializeProductPromo);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-dm-handbag-banner]'), initializeBanner);
    if (scope.matches && scope.matches('[data-dm-handbag-product-promo]')) initializeProductPromo(scope);
    if (scope.matches && scope.matches('[data-dm-handbag-banner]')) initializeBanner(scope);
  }

  var api = {
    parseInstant: parseInstant,
    getWindowState: getWindowState,
    parseIdList: parseIdList,
    parseEligiblePrices: parseEligiblePrices,
    calculateOffer: calculateOffer,
    formatMoney: formatMoney,
    initializeProductPromo: initializeProductPromo,
    initializeBanner: initializeBanner,
    initializeAll: initializeAll
  };

  global.DellamodaHandbagEvent = api;

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', function () { initializeAll(global.document); });
    } else {
      initializeAll(global.document);
    }
    global.document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
    global.document.addEventListener('shopify:section:unload', function (event) {
      Array.prototype.forEach.call(event.target.querySelectorAll('[data-dm-handbag-product-promo]'), function (root) {
        if (root.dmHandbagPromoDestroy) root.dmHandbagPromoDestroy();
      });
      Array.prototype.forEach.call(event.target.querySelectorAll('[data-dm-handbag-banner]'), function (root) {
        if (root.dmHandbagBannerDestroy) root.dmHandbagBannerDestroy();
      });
    });
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
}(typeof window !== 'undefined' ? window : globalThis));
